import { render, staticRenderFns } from "./PlatformListPage.vue?vue&type=template&id=78800d94&scoped=true"
import script from "./PlatformListPage.vue?vue&type=script&lang=js"
export * from "./PlatformListPage.vue?vue&type=script&lang=js"
import style0 from "./PlatformListPage.vue?vue&type=style&index=0&id=78800d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78800d94",
  null
  
)

export default component.exports